module.exports = __webpack_public_path__ + "img/AT0000002639662.b0f17f7c.png";